import { CARDS_API_ENDPOINTS } from "@/features/card/configs/cardsApiPath.config";
import type { CardActivationFormData } from "@/features/card/schemas/forms/cardActivationForm.schema";
import type { GetCardsResponse, GetPinCardResponse, PutOnCardResponse } from "@/features/card/types/card.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getUserCards = async (): Promise<GetCardsResponse["cards"]> => {
  const response = await fetcher.get<GetCardsResponse>(CARDS_API_ENDPOINTS.GET_CARDS);
  return response.data.cards;
};

export const lockCard = async (cardId: string): Promise<PutOnCardResponse> => {
  const response = await fetcher.put(CARDS_API_ENDPOINTS.LOCK_CARD.replace(":cardId", cardId));
  return response.data;
};

export const unlockCard = async (cardId: string): Promise<PutOnCardResponse> => {
  const response = await fetcher.put(CARDS_API_ENDPOINTS.UNLOCK_CARD.replace(":cardId", cardId));
  return response.data;
};

export const activateCard = async (cardId: string, data: CardActivationFormData): Promise<PutOnCardResponse> => {
  const response = await fetcher.put(
    CARDS_API_ENDPOINTS.ACTIVATE_CARD.replace(":cardId", cardId),
    data,
  );
  return response.data;
};

export const getPinCard = async (cardId: string): Promise<GetPinCardResponse> => {
  const response = await fetcher.get(CARDS_API_ENDPOINTS.GET_PIN_CARD.replace(":cardId", cardId));
  return response.data;
};
